// Lodash
import _ from 'lodash';
window._ = _;

// jQuery and Bootstrap
// 1. Import jQuery and expose globally
import $ from 'jquery';
window.$ = window.jQuery = $;

// 2. Import Bootstrap (must be after jQuery)
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;


// Select2 (after jQuery)
import 'select2/dist/js/select2.min.js';
import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.css';


import * as Popper from '@popperjs/core';
window.Popper = Popper;

import 'bootstrap';

// datepicker.js
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
document.addEventListener("DOMContentLoaded", function () {
    $('.datepicker').datepicker({
        format: 'yyyy-mm-dd',
    });
});

// Moment.js
import moment from 'moment';
window.moment = moment;

// SweetAlert and SweetAlert2
import swal from 'sweetalert';
window.swal = swal;

import Swal from 'sweetalert2';
window.Swal = Swal;


// Axios
import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
